import angular from 'angular';

export default angular.module('cms.dashboard.logsFeed', [])
    .component('logsFeed', {
       template: require('./logFeed.html'),
       controller: function(LogResource, $scope, gettextCatalog) {
           LogResource.get({limit: 30}, response => {
                $scope.logs = response.data;
           });

           $scope.getLogMessage = (log) => {
                let isNotUniqueEvent = log.event !== 'login' && log.event !== 'reset_password'
                let action = '';
                let subject = isNotUniqueEvent ? gettextCatalog.getString(log.context.split('\\').pop()) : '';
                let element = isNotUniqueEvent ? gettextCatalog.getString('element:') : '';
                switch(log.event) {
                    case 'login':
                        action = gettextCatalog.getString('Logged in');
                        break;
                    case 'update':
                        action = gettextCatalog.getString('Updated');
                        break;
                    case 'create':
                        action = gettextCatalog.getString('Created');
                        break;
                    case 'delete':
                        action = gettextCatalog.getString('Deleted');
                        break;
                    case 'reset_password':
                        action = gettextCatalog.getString('Changed password');
                        break;
                    default:
                        action = gettextCatalog.getString('Other action');
                }

                return action + " " + element + " " + subject;
           }
       }
    }).name;


// WEBPACK FOOTER //
// ./src/cmsPages/Dashboard/logFeed/LogFeed.js